import Vue from "vue";
import ImageCloudinary from "image-cloudinary";

Vue.use(ImageCloudinary);
